import { BaseButton } from "components/buttons/BaseButton";
import { useEffect, useState } from "react";
import { UseFormGetValues, UseFormSetValue, FieldPath } from "react-hook-form";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import UploadSearch from "components/upload/UploadSearch";
import tick from "components/icons/tick.svg";
import UploadNicheItem from "components/upload/UploadNicheItem";
import { useKeyPress } from "hooks/useKeyPress";
import { ISignUpFieldValues } from "../AuthSignUp";
import { INiche } from "services/types";
import classes from "./SignUpNichesStep.module.scss";
import authPopupClasses from "./../AuthPopup.module.scss";
import { clsx } from "clsx";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
  getValues: UseFormGetValues<ISignUpFieldValues>;
  disabled: boolean;
}

const SignUpNichesStep = (props: IProps) => {
  const { setValue, getValues, disabled, next } = props;

  const niches = useSelector((state: IAppState) => state.niches.niches);
  const [filteredNiches, setFilteredNiches] = useState<INiche[]>(niches.niches ? niches.niches : []);
  const [selectedNiches, setSelectedNiches] = useState<string[]>(getValues().niches ? getValues().niches : []);

  const enterPressed = useKeyPress("Enter");

  const search = (value: string) => {
    if (niches.niches) {
      if (value) {
        const newNiches = niches.niches.filter((el: INiche) => el.name.toLowerCase().includes(value.toLowerCase()));
        setFilteredNiches(newNiches);
      } else {
        setFilteredNiches(niches.niches ? niches.niches : []);
      }
    }
  };

  const handleSelectNiche = (niche: INiche) => {
    const newSelectedNiches = [...selectedNiches];
    let isExist = false;

    newSelectedNiches.forEach((el, index) => {
      if (el === niche.id) {
        isExist = true;
        newSelectedNiches.splice(index, 1);
      }
    });

    if (!isExist) {
      newSelectedNiches.push(niche.id);
    }
    setSelectedNiches(newSelectedNiches);
  };

  const handleNext = () => {
    if (selectedNiches.length > 0) {
      next();
    }
  };

  useEffect(() => {
    setValue<FieldPath<ISignUpFieldValues>>("niches", selectedNiches);
    // eslint-disable-next-line
  }, [selectedNiches])

  useEffect(() => {
    if (enterPressed) {
      handleNext();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <div className={authPopupClasses.ContentContainer}>
      <div className={classes.Title}>Select some Niches to personalise your experience:</div>

      <UploadSearch onSearch={search}/>

      <div className={classes.Niches}>
        {filteredNiches ? filteredNiches.map((el: INiche) => (
          <UploadNicheItem
            key={el.id}
            img={el.thumbnail}
            name={el.name}
            subscribers={el.subscribers}
            index={0}
            id={el.id}
            disabled={false}
            isSelected={!!selectedNiches.find((n: string) => n === el.id)}
            select={() => handleSelectNiche(el)}
            selected_icon={tick}
          />
        )) : <p style={{ fontSize: "14px" }}>We have some issues with loading niches. Please close and open the dialog and try again.</p>}
      </div>

      <div className={clsx(authPopupClasses.Footer, authPopupClasses.FooterFixed)}>
        <BaseButton type="button" onClick={handleNext} disabled={selectedNiches.length < 1 || disabled}>Next</BaseButton>
      </div>
    </div>
  );
};

export default SignUpNichesStep;
